import {
  MomentThumbnail,
  MomentUnavailableThumbnail,
  NoteThumbnail,
  NoteUnavailableThumbnail,
  SwapThumbnail,
  SwapUnavailableThumbnail,
} from "@/components/shared/entity-thumbnails";
import type { ChatRenderContext } from "@/components/shared/chat-message-types";
import { useEntityInteraction } from "@/lib/hooks/conversations/use-entity-interaction";

interface EntityInteractionThumbnailProps {
  message: {
    customType: string;
    data?: string;
  };
  context?: ChatRenderContext;
}

export function EntityInteractionThumbnail({
  message,
  context,
}: EntityInteractionThumbnailProps) {
  const {
    entityData,
    entity,
    isPending,
    isUnavailable,
    activityConfig,
    isEnabled,
    index,
    openInHub,
  } = useEntityInteraction(message);

  if (!entityData?.entity_id || !entityData.entity_type || !isEnabled) {
    return null;
  }

  if (isPending) {
    return null;
  }

  const previewUrl =
    entity?.moment?.images?.[0]?.thumbnailUrl ??
    entity?.swap?.mentorImage?.thumbnailUrl ??
    entityData.preview_url ??
    null;

  const secondPreviewUrl =
    entity?.swap?.menteeImage?.thumbnailUrl ??
    entityData.second_preview_url ??
    null;

  const noteContent = entity?.note?.content ?? entityData.note_preview ?? null;

  if (isUnavailable) {
    return (
      <div className="mb-1">
        {entityData.entity_type === "moment" && (
          <MomentUnavailableThumbnail size="md" />
        )}
        {entityData.entity_type === "note" && (
          <NoteUnavailableThumbnail size="md" />
        )}
        {entityData.entity_type === "swap" && (
          <SwapUnavailableThumbnail size="md" />
        )}
        {activityConfig && <activityConfig.UnavailableThumbnail size="md" />}
      </div>
    );
  }

  return (
    <button
      onClick={openInHub}
      className="mb-1 transition-transform hover:scale-105"
    >
      {entityData.entity_type === "moment" && (
        <MomentThumbnail previewUrl={previewUrl} size="md" />
      )}
      {entityData.entity_type === "note" && (
        <NoteThumbnail noteContent={noteContent} size="md" />
      )}
      {entityData.entity_type === "swap" && (
        <SwapThumbnail
          previewUrl={previewUrl}
          secondPreviewUrl={secondPreviewUrl}
          size="md"
        />
      )}
      {activityConfig && (
        <activityConfig.InteractionThumbnail
          entityId={entityData.entity_id}
          index={index}
          context={context}
        />
      )}
    </button>
  );
}
